import { MEMBERSHIP_MODELS } from "@r-and-a-shared-ui/common-kontent-client";
import { ReferralCodePanel } from "@r-and-a-shared-ui/common-ui";
import { kontentAiDataMapping } from "@r-and-a-shared-ui/core-data-mapping";

export default {
  component: () => ReferralCodePanel,
  mapEntryToProps: (entry: MEMBERSHIP_MODELS.ReferralCodePanel) =>
    kontentAiDataMapping.referral_code_panel(entry),
}